export default "__VITE_ASSET__433da8f8__"